import React from "react";
import {Button, Typography} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslate} from "../../../../hooks/translate.hook";

const {Text, Title} = Typography;

interface DashboardToolbarProps {
    loading: boolean;
    loadedAt?: string;
    onRefresh: () => Promise<void>;
}

export const DashboardToolbar: React.FC<DashboardToolbarProps> = ({loading, loadedAt, onRefresh}) => {
    const t = useTranslate();

    return (
        <div className="health-center-dashboard__toolbar">
            <div>
                <Title level={4}>
                    {t("HEALTH-CENTER.DASHBOARD.OVERVIEW", {defaultValue: "Checks overview"})}
                </Title>
                <Text type="secondary">
                    {loadedAt
                        ? t("HEALTH-CENTER.DASHBOARD.UPDATED-AT", {
                            value: loadedAt,
                            defaultValue: "Updated {{value}}",
                        })
                        : t("HEALTH-CENTER.DASHBOARD.MONITORING-DESCRIPTION", {
                            defaultValue: "Current state and schedule of all system checks",
                        })}
                </Text>
            </div>
            <Button
                icon={<FontAwesomeIcon icon={["fas", "sync"]} />}
                loading={loading}
                onClick={() => void onRefresh()}
            >
                {t("HEALTH-CENTER.DASHBOARD.REFRESH", {defaultValue: "Refresh"})}
            </Button>
        </div>
    );
};
